<template>
  <div class="footer rouge">
    <div class="footer-container">
      <div class="elements-container flex flex-col lg:flex-row justify-between">
        <div class="logo hidden lg:block">
          <img
            class="block"
            src="/images/logo/isologotipo.png"
            alt="Operegrino"
          />
          <div class="legal-links hidden lg:flex justify-between space-x-8">
            <a :href="routes.cookies">Cookies</a>
            <a :href="routes.privacy">{{ $t('routes.privacy') }}</a>
            <a :href="routes.legal">{{ $t('routes.legal') }}</a>
          </div>
        </div>
        <div class="footer-links flex flex-col lg:flex-row">
          <div class="links-left contact-links flex flex-col">
            <div class="flex flex-col">
              <span class="font-bold mt-2 lg:mt-0 uppercase">{{ $t('address') }}</span>
              <a target="_blank"
                class="font mt-4"
                href="https://www.google.es/maps/place/O'PEREGRINO+-+Marisqueria+Restaurant/@41.3855643,2.1561503,20.29z/data=!4m13!1m7!3m6!1s0x12a4a288c8554867:0xf6bfb9d6e49bd51a!2sC%2F+d'Arag%C3%B3+%26+C.+de+Villarroel,+08011+Barcelona!3b1!8m2!3d41.3856339!4d2.1561862!3m4!1s0x12a4a27e16914819:0x8d61d122835601a6!8m2!3d41.3856484!4d2.1563826">
                C/ Aragón, 150 - Esquina C/ Villarroel 08011 Barcelona
              </a>
              <p class="parking">
                <span>Parking:&nbsp;</span>
                <a target="_blank" href="https://www.google.es/maps/place/Puigmal+Parking/@41.3875473,2.1564613,19z/data=!4m13!1m7!3m6!1s0x12a4a288c8554867:0xf6bfb9d6e49bd51a!2sC%2F+d'Arag%C3%B3+%26+C.+de+Villarroel,+08011+Barcelona!3b1!8m2!3d41.3856339!4d2.1561862!3m4!1s0x12a4a28f1631691f:0xd5a6cae72f56b3d0!8m2!3d41.3873812!4d2.1565151">
                    C/ Valencia, 178, 08011 Barcelona
                </a>
              </p>
            </div>
            <div class="contact-links flex flex-col">
              <span class="font-bold mt-8 lg:mt-0 uppercase">{{ $t('contact') }}</span>
              <a href="tel:+34933233953" class="mt-4">933233953</a>
              <a href="mailto:operegrino1990@gmail.com">operegrino1990@gmail.com</a>
            </div>
          </div>
          <div class="links-right flex flex-col">
            <div class="flex flex-col">
              <span class="font-bold mt-8 lg:mt-0 uppercase">{{ $t('schedule') }}</span>
              <span class="font mt-4">{{ $t('tue') }} - {{ $t('sat') }}</span>
              <span class="font">13:00 - 16:00</span>
              <span class="font">20:00 - 00:00</span>
              <span class="font mt-2">{{ $t('sun') }}</span>
              <span class="font">13:00 - 16:00</span>
              <div class="social-icons flex space-x-6 mt-8">
                <a href="https://www.instagram.com/marisqueria_o_peregrino" target="_blank">
                    <icon-instagram />
                </a>
                <a href="https://www.facebook.com/marisqueriaoperegrino" target="_blank">
                    <icon-facebook />
                </a>
              </div>
              <div class="flex lg:hidden justify-center items-center space-x-5 mt-6 -mb-1">
                <a :href="routes.cookies" class="text-center leading-tight">Cookies</a>
                <a :href="routes.privacy" class="text-center leading-tight">{{ $t('routes.privacy') }}</a>
                <a :href="routes.legal" class="text-center leading-tight">{{ $t('routes.legal') }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconInstagram from '../../icons/IconInstagram.vue';
import IconFacebook from '../../icons/IconFacebook.vue';

export default {
  props: {
    routes: {
      type: Object,
      required: true,
    },
    currentRoute: {
        type: String,
        required: true,
    },
  },

  components: {
    IconInstagram,
    IconFacebook,
  },
};
</script>

<style lang="scss">
@import '../../../sass/_variables.scss';

.footer {
  width: 100%;
  .footer-message {
    background-color: #3a473b;
    padding: 2rem 1rem;
    p {
      max-width: 1200px;
      margin: auto;
      color: #c4cfc7;
      font-size: 14px;
      text-align: center;
    }
  }
  .footer-container {
    padding: 2rem 1rem;
    @media (min-width: 1024px) {
      padding: 5rem 2rem;
    }
    .elements-container {
      max-width: 500px;
      margin: auto;

      @media (min-width: 1024px) {
        max-width: 1200px;
      }

      .logo {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        img {
          max-width: 204px;
          width: 100%;
          margin-bottom: 26px;

          @media (min-width: 1024px) {
            max-width: 230px;
          }
        }
        p {
          font-size: 18px;
          line-height: 1.56;
        }
      }
      a {
        text-decoration: none;
      }

      .footer-links {
        max-width: 500px;
        .links-left {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          a {
            margin-bottom: 5px;
          }
          .parking {
            font-size: 14px;

            @media (min-width: 1024px) {
                font-size: 12px;
            }
          }
        }
        .links-right {
          @media (min-width: 1024px) {
            flex-basis: 16rem;
          }

          &,
          a,
          span {
            margin-bottom: 5px;
          }
          @media (min-width: 1024px) {
            margin-left: 1rem;
          }
          @media (min-width: 1280px) {
            margin-left: 5rem;
          }
        }
      }
    }
  }
}
</style>
